import padStart from 'lodash/padStart';

var padNumber = function padNumber(value) {
  return padStart("".concat(value), 2, '0');
};

var SECOND_IN_MSECONDS = 1000;
var MINUTE_IN_MSECONDS = 60 * SECOND_IN_MSECONDS;
var HOUR_IN_MSECONDS = 60 * MINUTE_IN_MSECONDS;
export var getHoursFromMsSeconds = function getHoursFromMsSeconds(value) {
  return Math.floor(value / HOUR_IN_MSECONDS);
};
export var getMinutesFromMsSeconds = function getMinutesFromMsSeconds(value) {
  var excludeHours = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var min = excludeHours ? value - getHoursFromMsSeconds(value) * HOUR_IN_MSECONDS : value;
  return Math.floor(min / MINUTE_IN_MSECONDS);
};
export var getSecondsFromMsSeconds = function getSecondsFromMsSeconds(value) {
  var excludeMinutes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var sec = excludeMinutes ? value - getMinutesFromMsSeconds(value) * MINUTE_IN_MSECONDS : value;
  return Math.floor(sec / SECOND_IN_MSECONDS);
};

var getTimePeriodString = function getTimePeriodString(value) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$withHours = _ref.withHours,
      withHours = _ref$withHours === void 0 ? false : _ref$withHours,
      _ref$withSeconds = _ref.withSeconds,
      withSeconds = _ref$withSeconds === void 0 ? true : _ref$withSeconds,
      _ref$leadingZero = _ref.leadingZero,
      leadingZero = _ref$leadingZero === void 0 ? true : _ref$leadingZero;

  var result = '';

  if (withHours) {
    var hours = getHoursFromMsSeconds(value);
    result += "".concat(leadingZero ? padNumber(hours) : hours, ":");
  }

  var minutes = getMinutesFromMsSeconds(value, withHours);
  result += "".concat(leadingZero || withHours ? padNumber(minutes) : minutes);

  if (withSeconds) {
    var seconds = getSecondsFromMsSeconds(value, true);
    result += ":".concat(padNumber(seconds));
  }

  return result;
};

export default getTimePeriodString;